/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Iban
 */
export interface Iban {
    /**
     * IBAN ID
     * @type {number}
     * @memberof Iban
     */
    id?: number;
    /**
     * Only status 5 allows the use of the IBAN for a money-out.<br/>1 = None.<br/>2 = Internal.<br/>3 = Not used.<br/>4 = Waiting to be verified by Lemon Way.<br/>5 = Activated.<br/>6 = Rejected by the bank.<br/>7 = Rejected, no owner.<br/>8 = Deactivated.<br/>9 = Rejected.<br/>
     * @type {number}
     * @memberof Iban
     */
    status?: IbanStatusEnum;
    /**
     * IBAN saved
     * @type {string}
     * @memberof Iban
     */
    iban?: string;
    /**
     * SWIFT BIC code associated with the IBAN
     * @type {string}
     * @memberof Iban
     */
    swift?: string;
    /**
     * IBAN Holder
     * @type {string}
     * @memberof Iban
     */
    holder?: string;
    /**
     * Indicates if a merchant IBAN or a virtual client IBAN
     * 1: Merchant IBAN
     * 2: IBAN virtual client
     * @type {number}
     * @memberof Iban
     */
    type?: number;
}


/**
 * @export
 */
export const IbanStatusEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9
} as const;
export type IbanStatusEnum = typeof IbanStatusEnum[keyof typeof IbanStatusEnum];


/**
 * Check if a given object implements the Iban interface.
 */
export function instanceOfIban(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IbanFromJSON(json: any): Iban {
    return IbanFromJSONTyped(json, false);
}

export function IbanFromJSONTyped(json: any, ignoreDiscriminator: boolean): Iban {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'iban': !exists(json, 'iban') ? undefined : json['iban'],
        'swift': !exists(json, 'swift') ? undefined : json['swift'],
        'holder': !exists(json, 'holder') ? undefined : json['holder'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function IbanToJSON(value?: Iban | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
        'iban': value.iban,
        'swift': value.swift,
        'holder': value.holder,
        'type': value.type,
    };
}

